module.exports = __webpack_public_path__ + "img/android-driver.d5a0d497.png";